
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {httpResource} from "@/resources/http.resource";
  import {IBalance} from "@/modules/Payment/interfaces/balance.interface";
  import * as emailValidator from 'email-validator';
  import PhoneInput from "@/components/PhoneInput.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IApp} from "@/interfaces/app.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IProfile} from "@/modules/Profile/interfaces/profile.interface";

  @Component({
    components: {
      AppDialog,
      PhoneInput,
    },
  })
  export default class PayByCard extends Vue {
    $refs: any;
    currentPopup = { blockName: 'payment', dialogName: 'payByCardPopup' };
    money = 0;
    disablePayFlag = false;

    formModel = {
      email: '',
      phone: '',
    };
    formRules = {
      email: [{
        validator: (rule, value, callback) => !value || emailValidator.validate(value) ? callback() : callback(new Error('Укажите email')),
        message: 'Укажите email',
        trigger: 'blur'
      }],
    };

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get isUser() { return this.storeState.auth.isUser; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }

    get emailField() { return this.formModel.email; }
    set emailField(value) {
      this.formModel.email = value;
      localStorage.setItem(IBalance.StorageKeys.BalanceEmail, value);
    }

    get phoneField() { return this.formModel.phone; }
    set phoneField(value) {
      this.formModel.phone = value;
      localStorage.setItem(IBalance.StorageKeys.BalancePhone, value);
    }

    async created() {
      let emailStorage = localStorage.getItem(IBalance.StorageKeys.BalanceEmail);
      let phoneStorage = localStorage.getItem(IBalance.StorageKeys.BalancePhone);
      this.formModel = {
        phone: this.payloadPopup.phone ? this.payloadPopup.phone : phoneStorage ? phoneStorage : '',
        email: this.payloadPopup.email ? this.payloadPopup.email : emailStorage ? emailStorage : '',
      };
      this.money = this.payloadPopup.tSum;
    }

    async pay() {
      try {
        const action = IBalance.ACTION_PAY;
        const hostUrl = window.location.origin;
        const resultPageUrl = IApp.RoutePath[IApp.ROUTE_NAME.PAGE_PAYMENT_RESULT];
        let params: any = {
          command: IBalance.Command.RegisterDo,
          returnUrl: `${hostUrl}${resultPageUrl}?type=payment&status=success`,
          failUrl: `${hostUrl}${resultPageUrl}?type=payment&status=error`,
          tSum: this.money,
        };
        if (this.payloadPopup && this.payloadPopup.carNumber) {
          params.carNumber = this.payloadPopup.carNumber;
        }
        else {
          params.corpId = this.storeState.auth.userAccess.corpId;
        }
        let optionalParams = ['gateId', 'payFromBalanceFlag',];
        optionalParams.forEach(param => {
          if (this.payloadPopup[param]) params[param] = this.payloadPopup[param];
        });

        const { data: { result: response } } = await httpResource.httpAction({ action, params });
        await this.$store.dispatch('dialog/openDialog', {
          blockName: 'payment',
          dialogName: 'bankIframePopup',
          payload: {
            ...this.payloadPopup,
            iframeUrl: `${hostUrl}${resultPageUrl}?type=payment&status=error`,
            closeAction: async () => {
              await this.onClose();
            },
          }
        });
      }
      catch (error) { await this.$store.dispatch('handleError', error, { root: true }); }
    }

    async goToPayment() {
      let carNumber = this.payloadPopup.carNumber;
      await this.$store.dispatch('dialog/closeAllDialogs');

      if (this.isUser) {
        this.$router.push({
          name: IApp.ROUTE_NAME.PAGE_PROFILE,
          hash: `#${IProfile.PageTab.Payment}`,
          params: { carNumber, }
        });
      }
      else {
        await this.$store.dispatch('openPage', {
          routeName: IApp.ROUTE_NAME.PAGE_REGISTRATION,
          query: { from: 'pay'},
          params: { carNumber, },
        });
      }
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
